import { graphql, useMutation } from "react-relay";
import { useWorkspaceSignalEditRemoveImagesMutation } from "./__generated__/useWorkspaceSignalEditRemoveImagesMutation.graphql";
import { useCallback } from "react";

export function useWorkspaceSignalEditRemoveImages() {
  const [removeImageMutation] =
    useMutation<useWorkspaceSignalEditRemoveImagesMutation>(graphql`
      mutation useWorkspaceSignalEditRemoveImagesMutation(
        $signalWorkspaceId: ID!
        $imageIds: [ID!]!
      ) {
        signalWorkspace(id: $signalWorkspaceId) {
          removeImages(imageIds: $imageIds) {
            id
            ...WorkspaceSignalEditMainEditedInfo_Signal
            descriptionImages {
              id
            }
          }
        }
      }
    `);

  return useCallback(
    (signalWorkspaceId: string, imageIds: string[]) => {
      return removeImageMutation({
        variables: {
          signalWorkspaceId,
          imageIds,
        },
      });
    },
    [removeImageMutation]
  );
}
